import React from 'react';
import moment from 'moment';
import { getStreamDates, filterDatesByEpisodes } from '../../../helpers/schedule-helper';
import { capitalizer } from '../../../../../cp/utils';
import { isSameAs, unixFormat } from '../../../helpers/times';
import { CTabs } from '../../UI';

export default React.memo(({
    stream,
    streamDate,
    playerEpisode,
    setStreamDate,
}) => {
    const streamDates = React.useMemo(() => {
        if (!stream) return null;

        const dates = getStreamDates(stream);

        if (!dates.length) return null;

        return filterDatesByEpisodes(dates, stream.episode).map((unixDate) => ({label: capitalizer(unixFormat(unixDate, 'ddd DD.MM.YY')), value: unixDate}));
    }, [stream]);

    React.useEffect(() => {
        if (!!streamDates?.length) {
            const currentDate = streamDates.find(({value: streamDate}) => isSameAs(streamDate, moment().unix()))?.value ?? null;

            if (!streamDate || !streamDates.find(({value}) => value === streamDate)) {
                setStreamDate(currentDate ?? streamDates[0].value);
            }

        }
    }, [streamDates]);

    React.useEffect(() => {
        if (playerEpisode && !!streamDates?.length && !isSameAs(playerEpisode.timeStart, streamDate)) {
            streamDates.forEach(({value}) => {
                if (isSameAs(value, playerEpisode.timeStart)) {
                    setStreamDate(value);
                }
            });
        }
    }, [playerEpisode]);

    if (!streamDates?.length || streamDates?.length <= 1) {
        return null;
    }

    return (
        <CTabs
            value={streamDate}
            tabs={streamDates}
            onChange={setStreamDate}
        />
    )
});
